export default "__VITE_ASSET__02f5dfd0__"